<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleInsert()"
        >新增</a-button
      >
    </div>
    <s-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :data="loadData"
      :loading="loading"
      :pagination="pagination"
      :scroll="{ x: screenWidth, y: screenHeight }"
    >
      <template slot="actions" slot-scope="data, record">
        <a-dropdown>
          <a class="ant-dropdown-link"
            >更多
            <a-icon type="down"></a-icon>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a @click="handleEdit(record)">修改</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record.id)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </s-table>
    <ComScheduleJobColumnsModal
      ref="ComScheduleJobColumnsModal"
      @ok="$refs.table.refresh(false)"
    />
  </a-card>
</template>
<script>
import { STable } from "@/components";
import ComScheduleJobColumnsModal from "./modules/ComScheduleJobColumnsModal";
import { findPage, del } from "@/api/system/comScheduleJob";

const columns = [
  {
    dataIndex: "jobName",
    ellipsis: true,
    sorter: true,
    title: "任务名称"
  },
  {
    dataIndex: "jobType",
    ellipsis: true,
    sorter: true,
    title: "任务类型",
    customRender: value => {
      if (value === "J") return "java对象";
      if (value === "S") return "shell脚本";
      return "未知";
    }
  },
  {
    dataIndex: "jobObject",
    ellipsis: true,
    sorter: true,
    title: "对象名称"
  },
  {
    dataIndex: "cronExpression",
    ellipsis: true,
    sorter: true,
    title: "触发时间"
  },
  {
    dataIndex: "runStatus",
    ellipsis: true,
    sorter: true,
    title: "任务当前状态",
    customRender: value => {
      if (value === "A") return "常态";
      if (value === "R") return "正在运行";
      if (value === "P") return "暂停";
      return "未知";
    }
  },
  {
    dataIndex: "lastRunStartTime",
    ellipsis: true,
    sorter: true,
    title: "上次运行开始时间"
  },
  {
    dataIndex: "lastRunEndTime",
    ellipsis: true,
    sorter: true,
    title: "上次运行结束时间"
  },
  {
    dataIndex: "runResult",
    ellipsis: true,
    sorter: true,
    title: "运行结果",
    customRender: value => {
      if (value === 1) return "正常结束";
      if (value === 2) return "有异常";
      return "未知";
    }
  },
  {
    dataIndex: "runMessage",
    ellipsis: true,
    sorter: true,
    title: "运行信息"
  },
  {
    title: "操作",
    width: 130,
    fixed: "right",
    scopedSlots: { customRender: "actions" }
  }
];
export default {
  components: {
    ComScheduleJobColumnsModal,
    STable
  },
  data() {
    return {
      //window
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight * 0.5,
      //form
      form: this.$form.createForm(this),
      //table
      loading: false,
      pagination: { showQuickJumper: true },
      columns,
      // 查询参数
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        const requestParameters = Object.assign(
          {},
          parameter,
          this.queryParam,
          this.form.getFieldsValue()
        );
        return findPage(requestParameters).then(res => {
          return res;
        });
      }
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = document.body.clientWidth;
      this.screenHeight = document.body.clientHeight * 0.5;
    });
  },
  methods: {
    //重置
    handleReset() {
      this.form.resetFields();
    },
    //新增
    handleInsert() {
      this.$refs.ComScheduleJobColumnsModal.show();
    },
    //修改
    handleEdit(record) {
      this.$refs.ComScheduleJobColumnsModal.show(record);
    },
    //删除
    handleDel(id) {
      let that = this;
      let params = { ids: id };
      this.$confirm({
        title: "提示",
        content: "是否确认删除该数据?",
        onOk() {
          that.loading = true;
          del({ ...params }).then(res => {
            if (res.resultCode === 1) {
              that.$notification.success({ message: res.message });
            } else {
              that.$notification.error({ message: res.message });
            }
            that.$refs.table.refresh(false);
          });
        }
      });
    }
  }
};
</script>
<style></style>
